(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const mobileNavs = document.querySelectorAll('.fm-header-shell .fm-mobile-nav');
    const dropdowns = document.querySelectorAll('.fm-header-shell .fm-navbar-dropdown');
    const desktopBreakpoint = window.matchMedia('(min-width: 992px)');

    const closeDropdown = (dropdown) => {
      const toggle = dropdown.querySelector('.fm-nav-toggle');

      dropdown.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    };

    const closeDropdowns = (exceptDropdown = null) => {
      dropdowns.forEach((dropdown) => {
        if (dropdown !== exceptDropdown) closeDropdown(dropdown);
      });
    };

    dropdowns.forEach((dropdown) => {
      const toggle = dropdown.querySelector('.fm-nav-toggle');
      const links = dropdown.querySelectorAll('.fm-dropdown-list a');

      if (!toggle) return;

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = !dropdown.classList.contains('is-open');

        closeDropdowns(dropdown);
        dropdown.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', String(isOpen));
      });

      links.forEach((link) => {
        link.addEventListener('click', () => closeDropdown(dropdown));
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.fm-header-shell .fm-navbar-dropdown')) {
        closeDropdowns();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDropdowns();
    });

    mobileNavs.forEach((mobileNav) => {
      const shell = mobileNav.closest('.fm-header-shell');
      const toggle = mobileNav.querySelector('.fm-mobile-toggle');

      if (!shell || !toggle) return;

      const closeMobileDetails = () => {
        shell.querySelectorAll('.fm-mobile-panel details[open]').forEach((details) => {
          details.removeAttribute('open');
        });
      };

      const closeMenu = () => {
        mobileNav.classList.remove('is-open');
        shell.classList.remove('is-mobile-nav-open');
        toggle.setAttribute('aria-expanded', 'false');
        closeMobileDetails();
      };

      toggle.addEventListener('click', () => {
        const isOpen = !mobileNav.classList.contains('is-open');

        if (!isOpen) {
          closeMenu();
          return;
        }

        mobileNav.classList.add('is-open');
        shell.classList.toggle('is-mobile-nav-open', isOpen);
        toggle.setAttribute('aria-expanded', String(isOpen));
      });

      desktopBreakpoint.addEventListener('change', (event) => {
        if (event.matches) closeMenu();
        if (!event.matches) closeDropdowns();
      });
    });
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 991px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
